import * as angular from 'angular';

import Age from "./Age";
import AlertDismissable from "./AlertDismissable";
import BootstrapFormValidation from "./BootstrapFormValidation";
import BottomNav from "./BottomNav";
import ClickToCopy from './ClickToCopy';
import ClickToDial from "./ClickToDial";
import CurrencyFilter from "./CurrencyFilter";
import Debug from './Debug';
import FormGroupInput from "./FormGroupInput";
import Highlight from "./Highlight";
import Modal from "./Modal";
import NgEnter from "./NgEnter";
import Panel from "./Panel";
import Popout from "./Popout";
import Sortable from './Sortable';
import StringToDate from "./StringToDate";
import TelDirective from "./TelDirective";
import TelFilter from "./TelFilter";
import UrlEscapeFilter from "./UrlEscapeFilter";
import GmailComposeDirective from "./GmailComposeDirective";
import DurationFilter from "./DurationFilter";


export default angular.module('app.directives', [
    Age,
    AlertDismissable,
    BootstrapFormValidation,
    BottomNav,
    ClickToCopy,
    ClickToDial,
    CurrencyFilter,
    Debug,
    FormGroupInput,
    Highlight,
    Modal,
    NgEnter,
    Panel,
    Popout,
    Sortable,
    StringToDate,
    TelDirective,
    TelFilter,
    UrlEscapeFilter,
    GmailComposeDirective,
    DurationFilter
])
    .name;
